import { contentRoutes } from 'constants/navigation';

export const subNavigationConfig = [
  {
    title: 'Soft skills',
    path: contentRoutes.softSkills.path,
  },
  {
    title: 'Technical skills',
    path: contentRoutes.technicalSkills.path,
  },
  {
    title: 'Traits',
    path: contentRoutes.traits.path,
  },
  {
    title: 'Interview question content',
    path: contentRoutes.interviewQuestionContent.path,
  },
  {
    title: 'Trait content',
    path: contentRoutes.traitContent.path,
  },
  {
    title: 'Behaviour content',
    path: contentRoutes.behaviourContent.path,
  },
];
